// eslint-disable-next-line
import { stockExportQueryFilter, stockLedgerQueryFilter, stockoutQueryFilter, stockQueryFilter } from 'utils/proptypes';
import base from './baseApi';
import { omitBy } from 'lodash';
import { createSearchParams } from 'react-router-dom';

const { urls, methods, execute } = base();
const getStocksByFilter = (queryFilter: stockQueryFilter) => {
  const method = methods.GET;
  const initParams: any = omitBy(queryFilter, v => v === '');
  const params = createSearchParams(initParams);

  const url = `${urls.stock.stock}/?${params.toString()}`;
  const response = execute(method, url, { authorization: true });

  return response;
};

const getStockLedgersByFilter = (queryFilter: stockLedgerQueryFilter) => {
  const method = methods.GET;
  const initParams: any = omitBy(queryFilter, v => v === '');
  const params = createSearchParams(initParams);

  const url = `${urls.stock.stock}/stock-ledger?${params.toString()}`;
  const response = execute(method, url, { authorization: true });

  return response;
};

const getStocks = () => {
  const method = methods.GET;
  const url = `${urls.stock.stock}?limit=10`;
  const response = execute(method, url, { authorization: true });

  return response;
};

const getStockById = (id: string) => {
  const method = methods.GET;
  const url = `${urls.stock.stock}/${id}`;
  const response = execute(method, url, { authorization: true });

  return response;
};

const getStockByItemAndLocation = (locationId: string, itemId: string) => {
  const method = methods.GET;
  const url = `${urls.stock.stock}/by-item/${locationId}/${itemId}`;
  const response = execute(method, url, { authorization: true });

  return response;
};

const createStock = (payload: any) => {
  const method = methods.POST;
  const url = `${urls.stock.stock}`;
  const response = execute(method, url, { authorization: true }, payload);

  return response;
};

const updateStockById = (id: any,payload: any) => {
  const method = methods.PUT;
  const url = `${urls.stock.stock}/${id}`;
  const response = execute(method, url, { authorization: true }, payload);
  return response;
};

const deleteStockById = (id: string) => {
    const method = methods.DELETE;
    const url = `${urls.stock.stock}/${id}`;
    const response = execute(method, url, { authorization: true });
  
    return response;
  };

  const exportStockFormOrg = (orgId: string, queryFilter: stockExportQueryFilter) => {
    const method = methods.GET;
    const initParams: any = omitBy(queryFilter, v => v === '');
    const params = createSearchParams(initParams);
    const url = `${urls.stock.stock}/${orgId}/export-stock/?${params.toString()}`;
    const response = execute(method, url, { authorization: true, responseTye: 'blob' });
  
    return response;
  };

  const exportStockLedgerFormOrg = (orgId: string, queryFilter: stockExportQueryFilter) => {
    const method = methods.GET;
    const initParams: any = omitBy(queryFilter, v => v === '');
    const params = createSearchParams(initParams);
    const url = `${urls.stock.stock}/${orgId}/export-stock-ledger/?${params.toString()}`;
    const response = execute(method, url, { authorization: true, responseTye: 'blob' });
  
    return response;
  };

  const exportReconcillationReport = (orgId: string, queryFilter: stockExportQueryFilter) => {
    const method = methods.GET;
    const initParams: any = omitBy(queryFilter, v => v === '');
    const params = createSearchParams(initParams);
    const url = `${urls.stock.stock}/${orgId}/export-reconcillation-report/?${params.toString()}`;
    const response = execute(method, url, { authorization: true, responseTye: 'blob' });
  
    return response;
  };

  const statisticsSaleItem = (itemId: string, locationId: string, numDay: number) => {
    const method = methods.GET;
    const url = `${urls.stock.stock}/${locationId}/statistics/${itemId}/${numDay}`;
    const response = execute(method, url, { authorization: true });
  
    return response;
  };

const getStockouts = (queryFilter: stockoutQueryFilter) => {
  const method = methods.GET;
  const initParams: any = Object.fromEntries(
    Object.entries(queryFilter).filter(([, v]) => v !== undefined && v !== ''),
  );
  const params = new URLSearchParams(initParams).toString();
  const url = `${urls.stock.stock}/stockouts?${params}`;
  return execute(method, url, { authorization: true });
};

const getOpenStockout = (stockId: string) => {
  const method = methods.GET;
  const url = `${urls.stock.stock}/stockouts/${stockId}/open`;
  return execute(method, url, { authorization: true });
};

export {
    getStocksByFilter,
    getStockLedgersByFilter,
    getStocks,
    getStockById,
    getStockByItemAndLocation,
    createStock,
    updateStockById,
    deleteStockById,
    exportStockFormOrg,
    exportStockLedgerFormOrg,
    exportReconcillationReport,
    statisticsSaleItem,
    getStockouts,
    getOpenStockout,
};
